export default __webpack_public_path__ + "static/media/david_coriiu.458a5665.png";